import type { LeadsSearchRowKeys, LeadsTechColumnType } from "app/pages/sales-intelligence/modules/leads-search";

export enum ColumnType {
    Tech = "tech",
    TechSubCategory = "techSubCategory",
    TechCategory = "techCategory",
}

export type TechColumnType = LeadsTechColumnType;

export type TechColumnName = `${TechColumnType}:${string}`;

/**
 * A column the suggestion engine may emit. Technology columns are addressed by a dynamic `tech:*` id rather
 * than by a field on the row, so this vocabulary is wider than `LeadsSearchRowKeys` alone — which stays
 * narrow because it also types the API sort key (`ORDER_BY_MAP`).
 */
export type SuggestedColumnName = LeadsSearchRowKeys | TechColumnName;
